module.exports = __webpack_public_path__ + "twitter.png?4e3906375cfaa2425089f7915c3fc081";